export const AssociationStatusEnum = {
  Draft: 0,
  Approved: 1,
  Rejected: 2,
  Pending: 3,
  Delete: 4,
};
